
export function checkLogin() {

        let resp = window.localStorage.getItem("token-nestor-manager"); //* * * sessionstorage item is initialized by loginAdmin in requete.js

        return (resp !== null && resp !== "") // user already logged?
       
}

export function checkLoginMaster() {

        let resp = window.localStorage.getItem("token-nestor-manager-user"); //* * * sessionstorage item is initialized by loginAdmin in requete.js

        return (resp === "master" && checkLogin()) // user already logged?
       
}